import { useState, useLayoutEffect } from "react";
const useBetterMediaQuery = (mediaQueryString, defaultValue = false) => {
  const [matches, setMatches] = useState(defaultValue);
  useLayoutEffect(() => {
    const mediaQueryList = window.matchMedia(mediaQueryString);
    const documentChangeHandler = () => setMatches(!!mediaQueryList.matches);
    try {
      mediaQueryList.addEventListener("change", documentChangeHandler);
    } catch (e) {
      mediaQueryList.addListener(documentChangeHandler);
    }
    documentChangeHandler();
    return () => {
      try {
        mediaQueryList.removeEventListener("change", documentChangeHandler);
      } catch (e) {
        mediaQueryList.removeListener(documentChangeHandler);
      }
    };
  }, [mediaQueryString]);
  return matches;
};
export {
  useBetterMediaQuery as u
};
//# sourceMappingURL=useBetterMediaQuery.xTM_WrtF.mjs.map
